<template>
  <div>
    <div class="col-5 row">
      <div class="col-12 bg-fade-primary-8 mb-1">
        <div class="align-items-center row h-100 m-0">
          <div class="col">
            <p class="align-middle display-1 m-0">
              {{ day.temperature }}&#176;F
            </p>
          </div>
          <div
            v-if="day.icon_class !== ''"
            class="col"
          >
            <i
              class="wi display-1"
              :class="day.icon_class"
            />
          </div>
        </div>
      </div>
      <div class="col-12 bg-fade-primary-dark-8">
        <div class="align-items-center row h-100 m-0">
          <div
            v-if="day.windChill"
            class="col-6"
          >
            <p class="text-secondary display-5 text-start align-middle m-0">
              Wind Chill
            </p>
          </div>
          <div
            v-if="day.windChill"
            class="col-6"
          >
            <p class="display-5 align-middle m-0">
              {{ day.windChill }}&#176;F
            </p>
          </div>
          <div class="col-6">
            <p class="text-secondary display-5 text-start align-middle m-0">
              Wind
            </p>
          </div>
          <div class="col-6">
            <p class="display-5 align-middle m-0">
              {{ day.windSpeed }} mph {{ day.windDirection }}
            </p>
          </div>
          <div class="col-6">
            <p class="text-secondary display-5 text-start align-middle m-0">
              Humidity
            </p>
          </div>
          <div class="col-6">
            <p class="display-5 align-middle m-0">
              {{ day.humidity }}%
            </p>
          </div>
          <div class="col-6">
            <p class="text-secondary display-5 text-start align-middle m-0">
              Dew Point
            </p>
          </div>
          <div class="col-6">
            <p class="display-5 align-middle m-0">
              {{ day.dewPoint }}&#176;F
            </p>
          </div>
          <div
            v-if="day.pressureSurfaceLevel !== 'N/A'"
            class="col-6"
          >
            <p class="text-secondary display-5 text-start align-middle m-0">
              Pressure
            </p>
          </div>
          <div
            v-if="day.pressureSurfaceLevel !== 'N/A'"
            class="col-6"
          >
            <p class="display-5 align-middle m-0">
              {{ day.pressureSurfaceLevel }} inHg
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-7 bg-fade-primary-dark-8 row align-items-center m-0">
      <div class="col-6">
        <p class="text-secondary display-4 text-start align-middle m-0">
          Today's High
        </p>
      </div>
      <div class="col-6">
        <p class="display-4 align-middle m-0">
          {{ day.temperatureMax }}&#176;F
        </p>
      </div>
      <div class="col-6">
        <p class="text-secondary display-4 text-start align-middle m-0">
          Today's Low
        </p>
      </div>
      <div class="col-6">
        <p class="display-4 align-middle m-0">
          {{ day.temperatureMin }}&#176;F
        </p>
      </div>
      <div class="col-6">
        <p class="text-secondary display-4 text-start align-middle m-0">
          Record High
        </p>
      </div>
      <div class="col-6 d-flex flex-column">
        <p class="display-4 align-middle m-0">
          {{ day.recordHigh.temp }}&#176;F
        </p>
        <p class="display-6 m-0">
          {{ day.recordHigh.year }}
        </p>
      </div>
      <div class="col-6">
        <p class="text-secondary display-4 text-start align-middle m-0">
          Record Low
        </p>
      </div>
      <div class="col-6 d-flex flex-column">
        <p class="display-4 align-middle m-0">
          {{ day.recordLow.temp }}&#176;F
        </p>
        <p class="display-6 m-0">
          {{ day.recordLow.year }}
        </p>
      </div>
      <div
        v-if="day.lowWindChill"
        class="col-6"
      >
        <p class="text-secondary display-4 text-start align-middle m-0">
          Low Wind Chill
        </p>
      </div>
      <div
        v-if="day.lowWindChill"
        class="col-6 d-flex flex-column"
      >
        <p class="display-4 align-middle m-0">
          {{ day.lowWindChill }}&#176;F
        </p>
        <p class="display-6 m-0">
          {{ day.lowWindChillTime }}
        </p>
      </div>
      <div
        v-if="day.precipitationProbability > 0 || day.precipitationIntensity > 0"
        class="col-6"
      >
        <p class="text-secondary display-4 text-start align-middle m-0">
          {{ day.precipitationType }}
        </p>
      </div>
      <div
        v-if="day.precipitationProbability > 0 || day.precipitationIntensity > 0"
        class="col-6 d-flex flex-column"
      >
        <p class="display-4 align-middle m-0">
          {{ day.precipitationProbability }}%
        </p>
        <p class="display-6 m-0">
          {{ day.precipitationIntensity }} in
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CurrentWeather',
  props: {
    day: {
      type: Object,
      required: true,
    },
  },
};
</script>
